<template>
  <v-dialog v-model="showPendingFaultUpdates" width="1240" height="640">
    <v-card style="width:100%;height:100%;">
      <v-card-title primary class="title" style="height:10%;">Verified Faults</v-card-title>
      <v-card-media
          style="height:80%; max-height:80%; overflow-y:auto; padding: 0 16px; width: calc(100% - 0)"
      >
        <v-layout column>
          <v-flex d-flex md8>
            <dx-data-grid
                class="grid"
                :data-source="pendingFaultsDataSource"
                :show-column-lines="true"
                :show-row-lines="true"
                :show-borders="true"
                :word-wrap-enabled="true"
                :row-alternation-enabled="false"
                :column-auto-width="true">
              <DxLoadPanel :enabled="false"/>
              <DxPaging :page-size="6"/>
              <dx-column data-field="vessel" caption="Vessel"/>
              <dx-column data-field="eng_type" caption="Engine Type"/>
              <dx-column data-field="fault" caption="Description"/>
              <dx-column data-field="component" caption="Component"/>
              <dx-column data-field="startDate"
                         caption="First Appearance"
                         data-type="datetime"
                         format="yyyy/MM/dd HH:mm"
              />
              <dx-column data-field="verified" caption="Status" cell-template="verifiedTemp"/>
              <div slot="verifiedTemp" slot-scope="{data}">
                <ColorRadioV2
                    :id="data.row.data.id"
                    :selected="data.row.data.verified"
                    :items="status_items"
                    :noChange="true"
                />
              </div>
            </dx-data-grid>
          </v-flex>
          <v-flex d-flex md4 style="padding-top: 16px;">
            <v-layout column>
              <v-flex d-flex md6>
                <v-text-field
                    v-model="username"
                    label="Username"
                />
              </v-flex>
              <v-flex d-flex md6>
                <v-textarea
                    v-model="comment"
                    label="Comment"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-media>
      <v-card-actions style="height:10%;">
        <v-spacer/>
        <v-btn color="primary" flat @click="cancelPendingFaultsDialog">Cancel</v-btn>
        <v-btn style="color:white; background-color: rgb(51,82,128);" @click="savePendingFaults">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {DxColumn, DxDataGrid, DxLoadPanel, DxPaging} from "devextreme-vue/data-grid";
import ColorRadioV2 from "@/components/ColorRadioV2";
import {store} from "@/main";
import axios from "axios";
import {createStore} from "devextreme-aspnet-data-nojquery";

export default {
  name: "PendingFaultsDialog",
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxLoadPanel,
    ColorRadioV2
  },
  props: {
    pending_updates: Object,
    callback: Function
  },
  data() {
    return {
      status_items: [
        {
          'value': -2,
          'color': 'white',
          'label': 'Pending'
        },
        {
          'value': 0,
          'color': 'red',
          'label': 'False'
        },
        {
          'value': 1,
          'color': 'green',
          'label': 'Verified'
        }
      ],
      pendingFaultUpdates: false,
      pendingFaultsDataSource: null,
      showPendingFaultUpdates: false,
      username: '',
      comment: ''
    }
  },
  methods: {
    setPendingFaultsDataSource() {
      this.pendingFaultsDataSource = createStore({
        loadMethod: 'POST',
        loadUrl: `${store.config.api_location}/faults/ids`,
        loadParams: {
          ids: JSON.stringify(this.pending_updates)
        },
        onLoading: (options) => {
          store.loading = true;
        },
        onLoaded: (data) => {
          console.log(111);
          store.loading = false;
          this.showPendingFaultUpdates = true;
        },
        onAjaxError: (e) => {
          store.loading = false;
        }
      })
    },
    openDialog: function () {
      // this.showPendingFaultUpdates = true;
      this.username = store.getUsername();
      this.setPendingFaultsDataSource();
    },
    cancelPendingFaultsDialog: function () {
      this.showPendingFaultUpdates = false;

      this.username = '';
      this.comment = '';
    },
    savePendingFaults: function () {
      let data = {
        faults: Object.keys(this.pending_updates).map((faultId => {
          let fault = this.pending_updates[faultId];

          return {
            id: faultId,
            verified: fault.verified
          }
        })),
        comment: this.comment,
        username: this.username
      }

      store.loading = true;
      axios
          .post(store.config.api_location + '/faults/update', data, {headers: {Authorization: store.userProfile.jwt}})
          .then((res) => {
            if (res.data.success) {
              this.pending_updates = {};

              this.callback();
              this.cancelPendingFaultsDialog();
            }
          })
          .catch((e) => {
          })
          .finally(() => {
            store.loading = false;
          });
    },
  }
}
</script>

<style scoped>

</style>